export default "/images/vendor/flag-icons/flags/4x3/pe.svg?d64e9732fcaa8f765994a9a7ff9f07f6";